import type { ItineraryDay } from "@/api/tour";
import { toCnDay } from "@/pages/route-detail-product/constants";

interface ItineraryProps {
  list?: ItineraryDay[];
  /** 是否使用紧凑模式（订单详情页用） */
  compact?: boolean;
}

export default function Itinerary({ list, compact = false }: ItineraryProps) {
  if (!list || list.length === 0) return null;

  if (compact) {
    return (
      <div className="mx-4 mt-3 bg-white rounded-2xl p-4">
        <div className="text-sm font-bold text-gray-900 mb-3">行程安排</div>
        <div className="space-y-0">
          {list.map((day) => (
            <div
              key={day.day_number}
              className="border-b border-gray-100 last:border-b-0"
              style={{ paddingBottom: 12, paddingTop: 12 }}
            >
              <div className="flex items-start gap-3">
                <span
                  className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold text-white"
                  style={{ background: "#2563EB" }}
                >
                  D{day.day_number}
                </span>
                <div className="flex-1 min-w-0 space-y-1.5">
                  {day.attractions && (
                    <div className="flex items-start gap-2">
                      <i className="ri-map-pin-2-line flex-shrink-0" style={{ color: "#9CA3AF", fontSize: 13 }} />
                      <span className="text-xs text-gray-700 leading-relaxed">{day.attractions}</span>
                    </div>
                  )}
                  {day.transportation && (
                    <div className="flex items-start gap-2">
                      <i className="ri-steering-2-line flex-shrink-0" style={{ color: "#9CA3AF", fontSize: 13 }} />
                      <span className="text-xs text-gray-700 leading-relaxed">{day.transportation}</span>
                    </div>
                  )}
                  {day.accommodation && (
                    <div className="flex items-start gap-2">
                      <i className="ri-hotel-bed-line flex-shrink-0" style={{ color: "#9CA3AF", fontSize: 13 }} />
                      <span className="text-xs text-gray-700 leading-relaxed">{day.accommodation}</span>
                    </div>
                  )}
                  {day.meals && (
                    <div className="flex items-start gap-2">
                      <i className="ri-restaurant-line flex-shrink-0" style={{ color: "#9CA3AF", fontSize: 13 }} />
                      <span className="text-xs text-gray-700 leading-relaxed">{day.meals}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // 默认模式（路线详情页用，卡片式）
  return (
    <div className="bg-white mt-2 px-5 py-4">
      <div className="text-sm font-semibold text-gray-800 mb-3">行程安排</div>
      <div className="space-y-3">
        {list.map((day) => (
          <div
            key={day.day_number}
            className="p-4 rounded-2xl"
            style={{ border: "1.5px solid #ECEEF2" }}
          >
            {/* Day header */}
            <div className="flex items-center gap-2.5 mb-3">
              <span
                className="px-2.5 py-1 rounded-full text-xs font-bold text-white flex-shrink-0"
                style={{ background: "#1E3A8A" }}
              >
                {toCnDay(day.day_number)}
              </span>
            </div>

            {/* Details */}
            <div className="space-y-1.5 ml-1">
              {day.attractions && (
                <div className="flex items-start gap-2">
                  <i className="ri-map-pin-2-line flex-shrink-0" style={{ color: "#9CA3AF", fontSize: 13 }} />
                  <span className="text-xs text-gray-400 w-8 flex-shrink-0">景点</span>
                  <span className="text-xs text-gray-700 leading-relaxed flex-1">{day.attractions}</span>
                </div>
              )}
              {day.transportation && (
                <div className="flex items-start gap-2">
                  <i className="ri-steering-2-line flex-shrink-0" style={{ color: "#9CA3AF", fontSize: 13 }} />
                  <span className="text-xs text-gray-400 w-8 flex-shrink-0">交通</span>
                  <span className="text-xs text-gray-700 leading-relaxed flex-1">{day.transportation}</span>
                </div>
              )}
              {day.accommodation && (
                <div className="flex items-start gap-2">
                  <i className="ri-hotel-bed-line flex-shrink-0" style={{ color: "#9CA3AF", fontSize: 13 }} />
                  <span className="text-xs text-gray-400 w-8 flex-shrink-0">住宿</span>
                  <span className="text-xs text-gray-700 leading-relaxed flex-1">{day.accommodation}</span>
                </div>
              )}
              {day.meals && (
                <div className="flex items-start gap-2">
                  <i className="ri-restaurant-line flex-shrink-0" style={{ color: "#9CA3AF", fontSize: 13 }} />
                  <span className="text-xs text-gray-400 w-8 flex-shrink-0">餐饮</span>
                  <span className="text-xs text-gray-700 leading-relaxed flex-1">{day.meals}</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
